export const limitMsg = (max: number) =>
  `Please limit your response to ${max} characters`;

export const minMsg = (min: number) => `Must be at least ${min} characters`;

interface ErrorMessageProps {
  value?: string | number;
  have?: number;
  min?: number;
  touched?: boolean;
  error?: string;
}

export default function ErrorMessage({
  value,
  have,
  min,
  touched,
  error,
}: ErrorMessageProps) {
  const str = String(value ?? "");
  const len = str.length;
  const isPhoneEmpty =
    str.startsWith("+") && str.replace(/\D/g, "").length <= 3;
  if (have !== undefined && len > have) {
    return <span className="field-error">{limitMsg(have)}</span>;
  }
  if (min !== undefined && !isPhoneEmpty && len > 0 && len < min) {
    return <span className="field-error">{minMsg(min)}</span>;
  }
  if (touched && error) {
    return <span className="field-error">{error}</span>;
  }
  return null;
}
